import { useContext } from 'react';
import { ContentRouting } from '../contexts/ContentRoutingContext';

function ContentRouter({children, contextPath}) {
    const cr = useContext(ContentRouting);
    if (cr.contentPath === contextPath) return children;
}

export { ContentRouter }